module.exports = __webpack_public_path__ + "static/media/error.bd4f03b0.svg";